export default {
  operation: {
    name: "顶部操作",
    children: [
      {
        type: "left",
        children: [
          // {
          //     name: 'language',
          //     title: '中文'
          // },
          {
            name: "page",
            title: "首页",
            list: [
              // {
              //   name: "首页"
              // },
              // {
              //   name: "二级页面"
              // }
            ]
          }
        ]
      },
      {
        type: "center",
        children: [
          {
            name: "pc",
            isActive: true
          },
          {
            name: "mobile",
            isActive: false
          }
        ]
      },
      {
        type: "right",
        children: [
          {
            name: "lock",
            title: "锁定",
            isActive: true
          },
          {
            name: "checkBox",
            title: "对齐辅助",
            isActive: true
          },
          {
            name: "history",
            title: "备份",
            isActive: true
          },
          {
            name: "previous",
            title: "撤销",
            isActive: false,
            iconClass: "icon-portal-return"
          },
          {
            name: "next",
            title: "重做",
            isActive: false,
            iconClass: "icon-portal-go-on"
          },
          {
            name: "preview",
            title: "预览",
            isActive: true
          },
          {
            name: "save",
            title: "保存",
            isActive: false,
            tips: "您还没有编辑记录"
          }
        ]
      }
    ]
  }
}
